import { render, staticRenderFns } from "./PriceSurchargeModal.vue?vue&type=template&id=8cd3ecba&scoped=true"
import script from "./PriceSurchargeModal.vue?vue&type=script&lang=ts"
export * from "./PriceSurchargeModal.vue?vue&type=script&lang=ts"
import style0 from "./PriceSurchargeModal.vue?vue&type=style&index=0&id=8cd3ecba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd3ecba",
  null
  
)

export default component.exports